import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useGetIptvServerQuery, useLazyGetIptvServerQuery } from '../../redux/apis/linkManagement/iptv/server/lmIptvServerApiSlice'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import EditCreateIptvPiracy from '../../components/IPTV/EditCreateIptvPiracy'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import { can } from '../../helpers/auth'
import IptvAppDropdown from '../../components/IptvAppDropdown'

const IptvPiracy = React.memo(() => {
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })

  const context = useContext(AppSettings)
  const { data, isLoading, error, isFetching } = useGetIptvServerQuery({
    expand: [
      'last_updated_by',
      'status',
      'iptv',
      'ip_address',
      'server_type',
      'customers',
      'real_isp_name'
    ].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ...(search ? { search } : {}),
    ...filters
  })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'APP NAME',
      dataIndex: 'iptv',
      key: 'iptv.app_name',
      filter: true,
      filterComponent:IptvAppDropdown,
      render: (text, record) => <div>{text?.app_name}</div>
    },
    {
      title: 'DOMAIN',
      dataIndex: 'domain',
      key: 'domain',
      filter: true,
      filterType: 'text'
    },

    {
      title: 'IP ADDRESS',
      dataIndex: 'ip_address',
      key: 'ip_address.ip_address',
      render: (text, record) => <div>{text?.ip_address}</div>
    },
    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: (text, record) => (
        <div className=''>
          {text.first_name} {text.last_name}
        </div>
      )
    },
    {
      title: 'STATUS',
      dataIndex: 'status',
      key: 'status.status_name',
      render: (text) => <div>{text?.status_name}</div>
    },
    {
      title: 'Status',
      dataIndex: 'status_name',
      key: 'status_name',
      hidden: true,
      filter: true,
      filterType: 'select',
      filterOptions: [
        { label: 'Active', value: 'Active' },
        { label: 'Disconnected', value: 'Disconnected' }
      ]
    },
    {
      title: 'UPDATED AT',
      dataIndex: 'updated_at',
      key: 'updated_at',
      render: (text) => <div>{text ? new Date(text).toLocaleString() : ''}</div>
    },
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          <Link
            className='btn btn-warning'
            to={`/iptv/iptv-piracy-servers-information/${record?.id}`}
          >
            View
          </Link>
          {can('change_iptvserver') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(record)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = record => {
    setHolder(record)
    setEdit(true)
  }

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])
  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) // Add context as a dependency

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      {can('add_iptvserver') && create ? (
        <EditCreateIptvPiracy
          state={'create'}
          open={create}
          setOpen={setCreate}
          record={null}
        />
      ) : null}
      {can('change_iptvserver') && edit ? (
        <EditCreateIptvPiracy
          state={'edit'}
          open={edit}
          setOpen={setEdit}
          record={holder}
        />
      ) : null}
      <div className='flex'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />

        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetIptvServerQuery}
            fileName='iptvPiracy'
          />
          {can('add_iptvserver') && (
            <button
              className='btn btn-outline-theme mb-4 '
              onClick={() => setCreate(true)}
            >
              Add Piracy Server Information
            </button>
          )}
        </div>
      </div>
      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default IptvPiracy
